import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { graphql, compose } from "react-apollo";
import UserEditForm from "./UserEditForm";
import UsersListQuery from "../queries/UsersList";
import CreateUserMutation from "../mutations/CreateUser";
import { addToCache } from "../utils/queryHelpers";

class UserNew extends React.Component {
  handleSubmit = values => {
    const { history } = this.props;
    this.props
      .createUser({
        id: this.props.id,
        input: values
      })
      .then(() => {
        history.push("/admin/users");
      });
  };

  render() {
    return (
      <Fragment>
        <Helmet>
          <title>New User</title>
        </Helmet>
        <UserEditForm
          onSubmit={this.handleSubmit}
          match={this.props.match}
          newUser
        />
      </Fragment>
    );
  }
}

const enhance = compose(
  graphql(CreateUserMutation, {
    props: ({ mutate }) => ({
      createUser({ input }) {
        return mutate({
          variables: { input },
          update: (store, { data: { createUser } }) => {
            addToCache(createUser, store, "users", {
              query: UsersListQuery
            });
          }
        });
      }
    })
  })
);

export default enhance(UserNew);



// WEBPACK FOOTER //
// ./src/components/UserNew.js